<script setup lang="ts">
import { callOnce, useCreators, useMaps } from "#imports";
import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import MPMapCard from "~/components/layouts/MPMapCard.vue";

const route = useRoute();
const creatorStore = useCreators();
const mapStore = useMaps();

const data = computed(() => {
  const creator = creatorStore.creatorByHandle;

  const maps = mapStore.getByIds(creator?.mapIds ?? []).value;

  return {
    ...creator,
    maps,
  };
});

const loadData = async () => {
  if (typeof route.params.handle !== "string") {
    return;
  }
  const creator = await creatorStore.fetchCreatorByHandle(route.params.handle);
  await mapStore.fetchByIds(creator.value!.mapIds);
};

await callOnce(loadData, { mode: "navigation" });
watch(() => route.params.handle, loadData);
</script>

<template>
  <section class="maps-container">
    <div
      v-for="map in data.maps"
      :key="map.id"
      :class="['map', data.maps.length === 1 ? 'single' : '']"
    >
      <MPMapCard :mapId="map.id" />
    </div>
  </section>
</template>

<style scoped lang="postcss">
@import "@/assets/css/breakpoints.pcss";

.maps-container {
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));

  .map {
    width: 100%;
    margin: 0 auto;
    &:deep(.cover) {
      display: block;
      object-fit: cover;
      max-width: 100%;
      max-height: 22rem;
    }
  }

  @mixin screen sm {
    .map.single {
      max-width: 60rem;
      margin: 0 auto;
      background-color: white;
      border-radius: 1rem;
      overflow: hidden;
      box-shadow: var(--shadow-base);
      border: 1px solid var(--color-slate-100);
      &:deep(.map-card) {
        grid-template-columns: 1.25fr 1fr;
        gap: 1.5rem;
        align-items: top;
      }
      &:deep(.cover) {
        border-radius: 0;
        max-height: 28rem;
      }
      &:deep(.overlay) {
        padding: 3rem 0 1rem;
        height: 100%;
        display: grid;
        grid-template-rows: auto auto auto 1fr;
      }
    }
  }

  /*@mixin screen xs {
    grid-template-columns: repeat(2, 1fr);
  }

  @mixin screen md {
    grid-template-columns: repeat(3, 1fr);
  }

  @mixin screen lg {
    grid-template-columns: repeat(4, 1fr);
  }*/
}
</style>
